
export default {
  name: "SavedMembers",

  data: () => ({
    toDelete: [],
  }),

  methods: {
    isToDelete(id) {
      if (this.toDelete.find((i) => i == id)) {
        return true;
      } else {
        return false;
      }
    },

    removeMember(id) {
      if (this.toDelete.find((i) => i == id)) {
        let index = this.toDelete.indexOf(id);
        this.toDelete.splice(index, 1);
      } else {
        this.toDelete.push(id);
      }
      this.$emit("change", this.toDelete);
    },
  },

  props: {
    members: Array,
  },
};
